<template>
  <!-- Extra container needed for custom classes -->
  <div class="tw-flex tw-flex-col">
    <div class="tw-flex tw-h-[400px] tw-flex-grow tw-flex-col tw-items-center tw-justify-center">
      <ClientOnly>
        <Map
          class="tw-h-full tw-w-full tw-flex-grow tw-rounded-t-lg"
          :options="{
            zoom: 5,
            center: {
              lat: polylineCoordinates[0][1],
              lng: polylineCoordinates[0][0]
            }
          }"
        >
          <template #default="{ map }">
            <MapCenter
              :duration="1000"
              :points="polylineCoordinates"
              :map="map"
              :zoom="30"
              @on-zoom-end="state.mapAnimationComplete = true"
            />

            <MapAnimatedLine
              :duration="1000"
              :coordinates="polylineCoordinates"
              :map="map"
              :properties="{
                color: '#08f'
              }"
            />

            <!-- Start marker -->
            <MapMarker
              :position="polylineCoordinates[0]"
              :map="map"
              :options="{ draggable: false, color: '#222' }"
            />

            <!-- End marker -->
            <MapMarker
              :position="polylineCoordinates[polylineCoordinates.length - 1]"
              :map="map"
              :options="{ draggable: false, color: '#222' }"
            />

            <!-- Image markers -->
            <MapMarker
              v-for="(photo, index) in sectionPhotos"
              :key="photo.id"
              :position="[photo.longitude, photo.latitude]"
              :map="map"
              :el="photoMarkers[index]"
              :options="{ draggable: false, color: '#222' }"
              @click="photoClicked(index, photo.id)"
            />
          </template>
        </Map>
      </ClientOnly>
    </div>

    <!-- Hidden image marker elements -->
    <div
      v-for="photo in sectionPhotos"
      :key="photo.id"
      :style="{ backgroundImage: `url(${photo.thumb})` }"
      class="tw-h-11 tw-w-11 tw-cursor-pointer tw-rounded tw-border-2 tw-border-white tw-bg-white tw-bg-cover tw-bg-center tw-transition-opacity tw-duration-1000"
      :class="[
        state.mapAnimationComplete ? 'tw-static tw-opacity-100' : 'tw-absolute tw-opacity-0'
      ]"
      ref="photoMarkers"
    ></div>

    <slot />
  </div>
</template>

<script setup lang="ts">
import polyline from '@mapbox/polyline'

const emit = defineEmits(['openImage', 'openImageId'])

const props = defineProps<{
  sectionPolyline: string
  sectionPhotos: any[]
}>()

const photoMarkers = ref<HTMLDivElement[]>([])

const state = reactive({
  mapAnimationComplete: false
})

const polylineCoordinates = computed(() => {
  if (!props.sectionPolyline) {
    return []
  }

  return polyline
    .decode(props.sectionPolyline, 6)
    .map((coordinate) => [coordinate[1], coordinate[0]])
})

const photoClicked = (index: number, photoId: number) => {
  emit('openImage', index)
  emit('openImageId', photoId)
}
</script>
